<script setup lang="ts">
import GaiaText from '../base/GaiaText.vue';
import { gaiaFontSize, gaiaNeutral } from '../themes/tokens';

const props = defineProps({
  /** Card title, e.g. "Extraction" or "Evaluation". */
  title: {
    type: String,
    required: true,
  },
  /** Muted subtitle after the title, e.g. "Information from document". */
  subtitle: {
    type: String,
    default: undefined,
  },
});

const border = gaiaNeutral.border;
const surface = gaiaNeutral.surface;
// `.body` is a slot wrapper, not a run of copy, so its type stays a rule.
const bodySize = gaiaFontSize.dense;
</script>

<template>
  <!-- Extraction / Evaluation card from the review detail (Kanban mock):
       header with title + subtitle + #actions (Trace), body in the default
       slot (GaiaFieldRow rows or prose), #footer for the prompt button. -->
  <n-flex vertical :size="11" class="gaia-extraction-card">
    <n-flex align="center" :size="10" :wrap="false">
      <gaia-text size="dense" weight="bold" tone="ink">{{ props.title }}</gaia-text>
      <gaia-text v-if="props.subtitle" size="meta" tone="faint">{{ props.subtitle }}</gaia-text>
      <n-flex
        v-if="$slots.actions"
        inline
        align="center"
        :size="8"
        :wrap="false"
        :style="{ marginLeft: 'auto', flex: 'none' }"
      >
        <slot name="actions" />
      </n-flex>
    </n-flex>
    <n-flex vertical :size="2" :style="{ fontSize: bodySize, lineHeight: 1.55 }"><slot /></n-flex>
    <div v-if="$slots.footer" :style="{ alignSelf: 'flex-start' }"><slot name="footer" /></div>
  </n-flex>
</template>

<style scoped>
.gaia-extraction-card {
  border: 1px solid v-bind(border);
  border-radius: 11px;
  padding: 13px 14px;
  background: v-bind(surface);
}
</style>
